var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-card" }, [
    _c(
      "header",
      { staticClass: "modal-card-head" },
      [
        _c("b-icon", {
          staticClass: "mr-2",
          attrs: { icon: "microchip", size: "is-medium" },
        }),
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  "admin.component.reseller.detail.resellerLoggers.list.addLoggerModal.title"
                )
              ) +
              " "
          ),
        ]),
      ],
      1
    ),
    _c(
      "section",
      { staticClass: "modal-card-body" },
      [
        _c(
          "b-field",
          {
            attrs: {
              label: _vm.$t(
                "admin.component.reseller.detail.resellerLoggers.addLoggers"
              ),
            },
          },
          [
            _c(
              "b-table",
              {
                staticClass: "select-location-table border select-user-table",
                attrs: {
                  data: _vm.availableLoggers,
                  "checked-rows": _vm.selectedLoggers,
                  paginated: true,
                  "per-page": 5,
                  narrowed: "",
                  checkable: "",
                  "mobile-cards": false,
                  "row-class": (row) =>
                    _vm.loggers.filter(
                      (x) =>
                        x.currentlyPublishedAs.companyLoggerId ===
                        row.currentlyPublishedAs.companyLoggerId
                    ).length > 0
                      ? "is-disabled has-text-grey"
                      : "",
                  "is-row-checkable": (row) =>
                    _vm.loggers.filter(
                      (x) =>
                        x.currentlyPublishedAs.companyLoggerId ===
                        row.currentlyPublishedAs.companyLoggerId
                    ).length === 0,
                },
                on: {
                  "update:checkedRows": function ($event) {
                    _vm.selectedLoggers = $event
                  },
                  "update:checked-rows": function ($event) {
                    _vm.selectedLoggers = $event
                  },
                  select: _vm.selectedLogger,
                },
              },
              [
                _c("b-table-column", {
                  attrs: {
                    field: "currentlyPublishedAs.serialNumber",
                    label: _vm.$t(
                      "admin.component.reseller.detail.resellerLoggers.list.addLoggerModal.form.selectAll"
                    ),
                    searchable: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "searchable",
                      fn: function (props) {
                        return [
                          _c("b-input", {
                            attrs: { size: "is-small" },
                            model: {
                              value: props.filters[props.column.field],
                              callback: function ($$v) {
                                _vm.$set(props.filters, props.column.field, $$v)
                              },
                              expression: "props.filters[props.column.field]",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (logger) {
                        return [
                          _c("span", [
                            _c(
                              "div",
                              {
                                staticClass: "field flex-space-between",
                                class: !_vm.loggers.find(
                                  (x) =>
                                    x.currentlyPublishedAs.companyLoggerId ===
                                    logger.row.currentlyPublishedAs
                                      .companyLoggerId
                                )
                                  ? "is-clickable"
                                  : "",
                              },
                              [
                                _c("div", {}, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        logger.row.currentlyPublishedAs
                                          .serialNumber
                                      ) +
                                      " (" +
                                      _vm._s(
                                        logger.row.currentlyPublishedAs
                                          .companyLoggerId
                                      ) +
                                      ") "
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "b-field",
          {
            attrs: {
              label: _vm.$t(
                "admin.component.reseller.detail.resellerLoggers.list.addLoggerModal.list.selected"
              ),
            },
          },
          [
            _c(
              "b-table",
              {
                staticClass:
                  "select-location-table border select-user-table-list",
                attrs: { data: _vm.selectedLoggers, striped: "" },
                scopedSlots: _vm._u([
                  {
                    key: "empty",
                    fn: function () {
                      return [
                        _c("section", { staticClass: "section" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "content has-text-grey has-text-centered",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "admin.component.reseller.detail.resellerLoggers.list.addLoggerModal.list.empty"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("b-table-column", {
                  attrs: {
                    field: "currentlyPublishedAs.serialNumber",
                    label: _vm.$t(
                      "admin.component.reseller.detail.resellerLoggers.list.addLoggerModal.list.name"
                    ),
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (assignLoggers) {
                        return [
                          _c("span", [
                            _c(
                              "div",
                              { staticClass: "field flex-space-between" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      assignLoggers.row.currentlyPublishedAs
                                        .serialNumber
                                    ) +
                                    " (" +
                                    _vm._s(
                                      assignLoggers.row.currentlyPublishedAs
                                        .companyLoggerId
                                    ) +
                                    ") "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "footer",
      {
        staticClass: "modal-card-foot",
        staticStyle: { "justify-content": "space-between" },
      },
      [
        _c(
          "b-button",
          {
            on: {
              click: function ($event) {
                return _vm.resultRetrieved(false)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("generals.close")))]
        ),
        _c(
          "b-button",
          {
            attrs: { type: "is-primary" },
            on: {
              click: function ($event) {
                return _vm.addResellerLoggers()
              },
            },
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "admin.component.reseller.detail.resellerLoggers.list.addLoggerModal.confirm"
                )
              )
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }